module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-57x57-d617152be9020ab3eb8e0905a2fb51b6.png";